<template>
	<div class="dialog-box">
		<el-dialog title="修改密码"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:modal-append-to-body="false"
			:show-close="showClose"
			width="400px">
			<div class="form-box">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm">
					<el-form-item label="旧密码" prop="oldUserPass">
						<el-input size="small" type="password" maxlength="16" placeholder="旧密码"
							v-model.trim="ruleForm.oldUserPass" show-password></el-input>
					</el-form-item>
					<el-form-item label="新密码" prop="userPass">
						<el-input size="small" type="password" maxlength="16" placeholder="新密码"
							v-model.trim="ruleForm.userPass" show-password></el-input>
					</el-form-item>
					<el-form-item label="确认密码" prop="userPass1">
						<el-input size="small" type="password" maxlength="16" placeholder="确认密码"
							v-model.trim="ruleForm.userPass1" show-password></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div class="flex flex-center">
				<el-button size="small" class="save-btn" type="primary" @click="submit()">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			// 确认密码
			var validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入确认密码！'));
				} else if (value !== this.ruleForm.userPass) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			return {
				dialogVisible: false,
				ruleForm: {
					userPass: "",
					userPass1: "",
					oldUserPass: "",
				},
				rules: {
					userPass: [
                        {
							required: true,
							message: '请输入新密码',
							trigger: 'blur'
						},
						{
							pattern: /^(?!^\d+$)(?!^[A-Za-z]+$)(?!^[^A-Za-z0-9]+$)(?!^.*[\u4E00-\u9FA5].*$)^\S{6,16}$/,
							message: '请输入6-16位英文大小写/数字/符号中任意两者组合',
							trigger: 'blur'
						},
					],
					userPass1: [
                        {
                            required: true,
                            validator: validatePass2,
                            trigger: 'blur'
                        },
                    ],
					oldUserPass: [
                        {
                            required: true,
                            message: '请输入旧密码',
                            trigger: 'blur'
                        },
                    ],
				},
				showClose: false
			}
		},
		methods: {
			init(showClose) {
				this.dialogVisible = true;
				this.showClose = showClose;
				this.$nextTick(() => {
					this.$refs.ruleForm.resetFields();
					this.ruleForm.userPass = '';
					this.ruleForm.userPass1 = '';
					this.ruleForm.oldUserPass = '';
				})
			},
			submit() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						if (this.dialogVisible == false) {
							return
						}
						let that = this;
						that.$request.post(
								"editPwd",
								true, {
									userId: JSON.parse(window.sessionStorage.getItem('userInfo')).userId,
									userPass: that.ruleForm.userPass,
									oldUserPass: that.ruleForm.oldUserPass,
								}
							)
							.then((res) => {
								if (res) {
									that.dialogVisible = false;
									that.$message.success('修改成功，请重新登录');
									window.sessionStorage.setItem("passwordExpiry", 0);
									setTimeout(() => {
										window.sessionStorage.clear();
										that.$router.push({
											name: 'login'
										})
									}, 1000);
								}
							})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
		}
	}

</script>
<style lang="scss" scoped>
	.title {
		margin: 10px 0;
	}

	.dialog-box {
		/deep/ .el-dialog__body {
			padding: 15px 20px;
		}
	}

</style>
